import moment from 'moment';

export class GenerateTerminalFileDownloadRequest {
    constructor(payload = {}) {
        this.requestFilter = {
            pageNumber: 1,
            pageSize: 1000,
            name: payload?.name ?? null,
            merchantId: payload?.terminalId ?? null,
            parentEntityCode: payload?.merchantId ?? null,
            status: payload?.status ?? null,
            sort: payload?.sort ?? 'createdOn',
            entityType: payload?.entityType ?? 'TERMINAL',
            enterpriseMerchant: payload?.enterpriseMerchant ?? true,
        };

        if (payload?.createdOn?.startDate && payload?.createdOn?.endDate) {
            this.requestFilter.startDate =
                moment(payload?.createdOn?.startDate)
                    .startOf('day')
                    .format('YYYY-MM-DD HH:mm:ss') ?? null;
            this.requestFilter.endDate =
                moment(payload?.createdOn?.endDate)
                    .endOf('day')
                    .format('YYYY-MM-DD HH:mm:ss') ?? null;
        }

        this.fileName = payload?.fileName ?? null;
        this.reportType = payload?.reportType ?? null;
    }
}